define([
    './_site',
    'jqueryUI'
], function(
    Site
) {
    var _self;
    // console.log('field-datepicker');

    // obj
    _self = {
        resize: function(event) {
            var $window = $(window),
                breakpoints = Site.breakpoints;

            if ($window.width() < breakpoints.md) {
                // datepicker
                _self.changeDateInputs(false);

            } else {
                // datepicker
                _self.changeDateInputs(true);
            }
        },
        changeDateInputs: function (flag) {
            var $menu = $('#menu');

            if (flag) {
                $('[data-plugin=datepicker]').attr('type', 'text').datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: 'dd-mm-yy'
                }).on('focus.fieldDatePicker', function () {
                    _self.initDatePicker($(this));
                });
            } else {
                $('[data-plugin=datepicker]').attr('type', 'date').datepicker('destroy').off('focus.fieldDatePicker', function () {
                    _self.initDatePicker($(this));
                });
            }

        },
        initDatePicker: function($el) {
            var date = new Date(),
                currentDate = $el.datepicker('getDate');

            if (!currentDate) {
                $el.datepicker('setDate', date);
                $el.trigger('checkEmpty');
                $('.ui-datepicker-prev, .ui-datepicker-next').remove();
            }
        }
    };


    // -------------------
    // BINDS
    // -------------------

    /// ---------------- window events
    $(window).on('resize.fieldDatepicker', function() {
        clearTimeout(Site.timeout.fieldDatepicker);
        Site.timeout.fieldDatepicker = setTimeout(function(){
            _self.resize();
        }, 100);
    });
    $(window).triggerHandler('resize.fieldDatepicker');

    return _self;
});
